import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import styles from './masters.module.scss';
import { Box, Divider, Grid, Stack } from '@mui/material';
import { capitalize } from '../../utils/util';
import { getStoreCheck, MASTERS } from './constants';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/FormControl/Icon';

const Masters = () => {
  const navigate = useNavigate();

  const isDisabled = (cardTitle: string) => {
    // Disability Check
    console.log(cardTitle);
    return false;
  };

  return (
    <Box className={styles.container}>
      <Box>
        {Object.entries(MASTERS()).map((data, index) =>
          data[1] && data[1].length > 0 ? (
            <Box key={index} className={styles.box}>
              {getStoreCheck(data[0]) && (
                <>
                  <Typography variant='h2' className={styles.title}>
                    <Icon size='1.3rem' icon={'ri-file-chart-line'} />
                    {`${capitalize(data[0])} Master`}
                  </Typography>
                  <Divider className={styles.divide} />
                </>
              )}
              <Grid container spacing={2}>
                {data[1].map((items, index) => (
                  <Grid key={index} item xs={3} className={styles.grid}>
                    <Card
                      className={`${styles.card} ${
                        isDisabled(items.name) ? styles.disabledCard : ''
                      }`}
                      onClick={(e) =>
                        isDisabled(items.name) ? e.preventDefault : navigate(items.url)
                      }
                    >
                      <CardContent className={styles.cardContent}>
                        <Typography gutterBottom variant='h5' component='div'>
                          {items.name}
                        </Typography>
                        <Typography fontSize={'12px'} variant='body2' color='text.secondary'>
                          {items.description}
                        </Typography>
                      </CardContent>
                      <Stack className={styles.background}>
                        <Icon icon='ri-arrow-right-line' className={styles.arrowIcon} />
                      </Stack>
                      {isDisabled(items.name) && (
                        <Stack className={styles.lockIconContainer}>
                          <Icon size='4rem' icon='ri-lock-fill' className={styles.lockIcon} />
                        </Stack>
                      )}
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : null,
        )}
      </Box>
    </Box>
  );
};

export default Masters;
